//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import Typography from "@material-ui/core/Typography";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import AuditorTasksTable from "src/components/auditor/table/AuditorTasksTable";

const LoaderTasksPage = () => {
  return (
    <>
      <Typography variant="h6" color="textSecondary">
        Results
      </Typography>
      <hr/>
      <div style={{marginTop: 20}}>
        <AuditorTasksTable/>
      </div>
    </>
  );
};
export default LoaderTasksPage;
